document.documentElement.classList.remove('no-js');
const header = document.querySelector('[data-header]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
window.addEventListener('scroll', () => header?.classList.toggle('is-scrolled', window.scrollY > 12), { passive: true });
menuToggle?.addEventListener('click', () => mobileMenu.classList.toggle('is-open'));
document.querySelectorAll('[data-language-select]').forEach((select) => {
  select.addEventListener('change', () => {
    if (select.form) select.form.requestSubmit();
  });
});
